
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/iframe/qrcode",
      function () {
        return require("private-next-pages/iframe/qrcode/index.tsx");
      }
    ]);
  